import script from "./FormulasIngredientCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredientCard.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredientCard.vue?vue&type=style&index=0&id=6f6cd042&lang=scss"

const __exports__ = script;

export default __exports__